const CheckQuyenBatDauQuyTrinh = () => {
  let check = false;
  
  if (localStorage.getItem('userInfo')) {
    
    let data = JSON.parse(localStorage.getItem('userInfo'));
    check = data.quyenBatDauQuyTrinh;
  }

  return check;
}

export { CheckQuyenBatDauQuyTrinh };



// WEBPACK FOOTER //
// ./src/components/modules/login/CheckQuyenBatDauQuyTrinh.js